/**
 * Invisible DOM markers so deep links can resolve a question by id or system_data
 * even when no gap/obligation notice is rendered.
 */
export const createQuestionnaireFocusMarkersExtension = () => {
    const QuestionnaireFocusMarkersExtension = (props) => {
        if (!props.displayQuestion) {
            return null;
        }

        const systemData =
            props.question?.systemData
            || props.question?.system_data
            || undefined;

        return (
            <span
                className="assessment-question-focus-marker visually-hidden"
                aria-hidden="true"
                data-assessment-question-id={
                    props.question?.id != null
                        ? String(props.question.id)
                        : undefined
                }
                data-assessment-question-system-data={systemData}
            />
        );
    };

    QuestionnaireFocusMarkersExtension.displayName =
        "QuestionnaireFocusMarkersExtension";

    return QuestionnaireFocusMarkersExtension;
};

export default createQuestionnaireFocusMarkersExtension;
